import paths from "@ingka/icons-shared/paths/warning-triangle-orange-small";
import { renderPaths } from "../renderPaths.mjs";
var warning_triangle_orange_small_default = () => renderPaths(paths);
export {
  warning_triangle_orange_small_default as default
};
